<template>
  <!-- <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{ $t("navigations.import study") }}</h2>
    </div>
  </div> -->
  <div class="row wrapper border-bottom white-bg page-heading">
    <!-- Title on the left -->
    <div class="col-10 align-self-center">
      <h2>{{ $t("navigations.import study") }}</h2>
    </div>

    <!-- <div class="col-2 text-right align-self-center">
      <div class="notification‐icon position-relative d-inline-block" @click="toggleNotificationPopup"
        style="cursor: pointer;" ref="bellIcon">
        <i class="fa fa-bell fa-lg mr-2"></i>

        <span v-if="notifications.length > 0" class="badge badge-danger" style="
            position: absolute;
            top: -6px;
            right: -8px;
            font-size: 0.75rem;
          ">
          {{ notifications.length }}
        </span>
      </div>
    </div> -->
  </div>

  <div class="wrapper wrapper-content px-0">
    <div class="ibox-content mb-1">
      <div class="step-indicator">
        <div 
          v-for="(step, index) in steps" 
          :key="index"
          class="step" 
          :class="{ 
            'active': currentStep === step.value, 
            'completed': currentStep > step.value 
          }"
        >
        <div class="step-number">{{ step.value }}</div>
        <div class="step-label">{{ step.label }}</div>
        <template v-if="currentStep === step.value" >
          <div  class="stepper-status d-flex" :class="{'stepper-status-active':currentStep === step.value}"  >
          <div><p class="mb-0">In Progress </p></div>
          <div class="position-relative custom-w">
            <div class="import-primary-loading"></div>
          </div>
         </div>
        </template>         
      </div>
      </div>
    </div>  
    <div v-if="currentStep==5" class="alert alert-info text-center mb-1 py-1">
      <h4 class="mb-0">{{$t('navigations.import Study Process Completed Successfully')}}</h4>
    </div>
    <div class="row">
      <template v-if="studyImported!=true">
        <!-- Import Protocol -->
        <uploadstudyprotocol></uploadstudyprotocol>
        <!-- Import Study -->
        <importstudymodel  @returnStudyId="setStudy($event)"></importstudymodel>
      
      </template>
    
      <template v-if="studyImported==true">
      <!-- Study Design Overview -->
      <div class="col-12 col-md-6 pr-1">
        <div class="ibox mb-2">
          <div class="ibox-title style_2">
            <h5>Electronic Case Report Forms (eCRFs)</h5>
          </div>
          <div class="ibox-content p-2">
            <div class="text-center" v-if="studyTemplates.length==0">
              <h4>{{$t('navigations.no eCRF templates available')}}</h4>
            </div>
            <div v-else>
              <div class="text-center" v-if="loadingECRFtemplates == true">
                  <img
                    src="../../assets/img/loading.gif"
                    width="15"
                    class=""
                    alt="Waiting for login"
                  />
                  <div>
                    {{ $t("navigations.please wait while the list is being loaded") }}
                  </div>
              </div>
              <div v-else class="table-responsive table-container">
                <table class="table table-hover mb-0">
                  <thead>
                    <tr>
                          <th>{{ $t("navigations.form name") }}</th>
                          <th>{{ $t("navigations.version") }}</th>
                          <th>{{ $t("navigations.language") }}</th>
                          <th>{{ $t("navigations.last updated") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="template in studyTemplates" :key="template.id">
                      <td>{{ template.templateName }}</td>
                      <td>{{ template.version }}</td>
                      <td>{{ template.language }}</td>                   
                      
                      <td>{{ filterDate(template.createdDate) }}</td>
                    </tr>
                  </tbody>
                </table>
             
              </div>
                 <div class="col-lg-12 d-flex justify-content-lg-end px-0 mt-2">
                  <v-pagination
                    v-model="currentTemplatePage"
                    :pages="totalTemplatePages"
                    :range-size="0"
                    active-color="#f4f9ff"
                  @update:modelValue="loadTemplate"
                  />
                </div>
           
            </div>
           
          </div>
        </div>
      </div>
      <!-- Visit  -->
      <div class="col-12 col-md-6 pl-1">
        <div class="ibox mb-2">
          <div class="ibox-title style_2">
            <h5>{{ $t('navigations.visits') }}</h5>
          </div>
          <div class="ibox-content p-2">
            <div class="text-center" v-if="visitList.length==0">
              <h4>{{$t('navigations.no visits available')}}</h4>
            </div>
            <div v-else >
              <div class="text-center" v-if="loadingVisitList == true">
                  <img
                    src="../../assets/img/loading.gif"
                    width="15"
                    class=""
                    alt="Waiting for login"
                  />
                  <div>
                    {{ $t("navigations.please wait while the list is being loaded") }}
                  </div>
              </div>
              <div v-else class="table-responsive table-container">
                <table class="table table-hover mb-0">
                <thead>
                  <tr>
                    <th>{{ $t("navigations.visit no") }}</th>
                    <th>{{ $t("navigations.visit name") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="visit in visitList" :key="visit.visitId">
                    <td>{{ visit.visitNo }}</td>
                    <td>{{ visit.visitFormName }}</td>
                  
                  </tr>
                </tbody>
                </table>
                 
              </div>
              <div class="col-lg-12 d-flex justify-content-lg-end px-0 mt-2">
                  <v-pagination
                    v-model="currentVisitPage"
                    :pages="totalVisitPages"
                    :range-size="0"
                    active-color="#f4f9ff"
                    @update:modelValue="loadVisit"
                  />
                </div>
            
            </div>
            
          </div>
        </div>
      </div>
      <!-- Sites-->
      <div class="col-12 col-md-6 pr-1">
        <div class="ibox mb-2">
          <div class="ibox-title style_2">
            <h5>{{ $t('navigations.sites') }}</h5>
          </div>
          <div class="ibox-content p-2">
            <div class="text-center" v-if="returnList.length==0">
              <h4>{{$t('navigations.no sites available')}}</h4>
            </div>
            <div v-else >
              <div class="text-center" v-if="loadingSiteList == true">
                  <img
                    src="../../assets/img/loading.gif"
                    width="15"
                    class=""
                    alt="Waiting for login"
                  />
                  <div>
                    {{ $t("navigations.please wait while the list is being loaded") }}
                  </div>
              </div>
              <div v-else class="table-responsive table-container">
                <table class="table table-hover mb-0">
                <thead>
                  <tr>
                <th>
                  {{ $t("navigations.site code") }}
                </th>
                <th
                >
                  <div class="d-flex flex-row justify-content-between">
                    {{ $t("navigations.site name") }}

                  </div>
                </th>
                <th
                  class="sort_block"
                  @click="SortSelected('status', 3)"
                  id="3"
                >
                  <div class="d-flex flex-row justify-content-between">
                    {{ $t("navigations.status") }}
                  </div>
                </th>
                <th
                >
                  <div class="d-flex flex-row justify-content-between">
                    {{ $t("navigations.contact name") }}
                  </div>
                </th>
                <th
                >
                  <div class="d-flex flex-row justify-content-between">
                    {{ $t("navigations.contact email") }}
                  </div>
                </th>
                <th>
                  {{ $t("navigations.number of subjects") }}
                </th>
                  </tr>
                </thead>
                <tbody>
                  <tr  v-for="item in returnList" :key="item.siteID">
                   <td>
                     {{ item.siteCode }}
                    </td>
                    <td>
                      {{ item.siteName }}
                    </td>
                    <td>{{ item.status }}</td>
                    <td>
                      {{ item.siteContactName }}
                    </td>
                    <td>
                      {{ item.siteContactEmail }}
                    </td>
                    <td>
                      {{ item.numberOfPatient }}
                    </td>
                  </tr>
                </tbody>
                </table>
                
              </div>
               <div class="col-lg-12 d-flex justify-content-lg-end px-0 mt-2">
                  <v-pagination
                    v-model="currentSitesPage"
                    :pages="totalSitesPages"
                    :range-size="0"
                    active-color="#f4f9ff"
                    @update:modelValue="loadSites"
                  />
                </div>
             
            </div>
          </div>
        </div>
      </div>

      <!-- Subjects Table -->
      <div class="col-12 col-md-6 pl-1">
        <div class="ibox mb-2">
          <div class="ibox-title style_2">
            <h5>{{ $t('navigations.subjects') }}</h5>
          </div>
          <div class="ibox-content p-2">
            <div class="text-center" v-if="patientLists.length==0">
              <h4>{{$t('navigations.no subjects available')}}</h4>
            </div>
            <div v-else >
              <div class="text-center" v-if="showPatientLoading == true">
                  <img
                    src="../../assets/img/loading.gif"
                    width="15"
                    class=""
                    alt="Waiting for login"
                  />
                  <div>
                    {{ $t("navigations.please wait while the list is being loaded") }}
                  </div>
              </div>
              <div v-else class="table-responsive table-container" >
                <table class="table table-hover mb-0">
                  <thead>
                      <tr>
                  <th>
                    {{ $t("navigations.site code") }}
                  </th>
                  <th>
                    {{ $t("navigations.subject id") }}
                  </th>
                  <th
                  >
                        {{ $t("navigations.status") }}
                  </th>
                  <th
                  >
                      {{ $t("navigations.language") }}
                  </th>
                  <th
                  >
                      {{ $t("navigations.country") }}
                  </th>
                  <th
                  >
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.investigator") }}
                    </div>
                  </th>
                  <th
                  >
                      {{ $t("navigations.enrolment date") }}
                  </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="patient in patientLists" :key="patient.studyId">
                  <td>
                    {{ patient.siteCode }}
                  </td>
                  <td>
                    {{ patient.subjectId }}
                  </td>
                  <td>{{ patient.status }}</td>
                  <td>
                    {{ patient.language }}
                  </td>
                  <td>
                    {{ patient.country }}
                  </td>
                  <td>
                    {{ patient.nurseName }}
                  </td>
                  <td>
                    {{ filter(patient.enrollmentDate) }}
                  </td>
                    </tr>
                  </tbody>
                </table>
                
              </div>
              <div class="col-lg-12 d-flex justify-content-lg-end px-0 mt-2">
                  <v-pagination
                    v-model="currentSubjectPage"
                    :pages="totalSubjectPages"
                    :range-size="0"
                    active-color="#f4f9ff"
                    @update:modelValue="loadPatients"
                  />
                </div>
            
            </div>
          </div>
        </div>
      </div>
        <!-- Recent Forms Table -->
      <div class="col-12">
        <div class="ibox mb-2">
          <div class="ibox-title style_2">
            <h5>{{ $t('navigations.recent forms') }}</h5>
          </div>
          <div class="ibox-content p-2">
            <div class="text-center" v-if="formlists.length==0">
              <h4>{{$t('navigations.no forms available')}}</h4>
            </div>
            <div v-else >
              <div class="text-center" v-if="showRecentFormsLoading == true">
                  <img
                    src="../../assets/img/loading.gif"
                    width="15"
                    class=""
                    alt="Waiting for login"
                  />
                  <div>
                    {{ $t("navigations.please wait while the list is being loaded") }}
                  </div>
              </div>
              <div v-else class="table-responsive table-container" >
                <table class="table table-hover mb-0">
                  <thead >             
                <tr >
                  <th>
                    {{ $t("navigations.site code") }}
                  </th>
                  <th>
                    {{ $t("navigations.subject id") }}
                  </th>
                  <th>
                    {{ $t("navigations.visit name") }}
                  </th>
                  <th>
                    {{ $t("navigations.form name") }}
                  </th>
                  <th>
                    {{ $t("navigations.status") }}
                  </th>
                  <th>
                    {{ $t("navigations.uploaded by") }}
                  </th>
                  <th>
                    {{ $t("navigations.uploaded date") }}
                  </th>
                </tr>
                  </thead>
                  <tbody>
                    <tr v-for="list in formlists" :key="list.formId">
                      <td>
                        {{ list.siteId }}
                      </td>
                      <td>
                        {{ list.subjectId }}
                      </td>
                      <td>
                        {{ list.visitName }}
                      </td>
                      <td>
                        {{ list.formName }}
                      </td>
                      <td>
                        {{ list.formStatus }}
                      </td>
                      <td>
                        {{ list.createdUserName }}
                      </td>
                      <td>
                        {{ filter(list.createdAt) }}
                      </td>
                    </tr>
                  </tbody>
                </table>                
              </div>
              <div class="col-lg-12 d-flex justify-content-lg-end px-0 mt-2">
                  <v-pagination
                    v-model="currentRecentFormsPage"
                    :pages="totalRecentFormsPage"
                    :range-size="0"
                    active-color="#f4f9ff"
                    @update:modelValue="loadRecentPages"
                  />
                </div>
            
            </div>
          </div>
        </div>
      </div>
      
      </template>
    </div>
  </div>
 
  <!-- Import Sections -->
<!-- Upload study protocol modal Starts -->
 <Teleport to="#wrapper">
  <uploadstudyprotocol @closeModal="closeprotocolpopup" v-if="uploadstudyprotocolpopup"/>
  </Teleport>
  <teleport to="#wrapper">
    <importstudymodel  ref="studymodel" @closeimportstudy="closeimportstudy" v-if="importstudymodal"/>
  </teleport>
  <transition name="fade">
    <div
      v-if="showNotifPopup"
      class="notification-popup bg-white border"
      ref="popup"
      style="
        position: absolute;
        top: 60px;  
        right: 20px;
        width: 260px;
        max-height: 320px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.15);
        border-radius: 4px;
        z-index: 1000;
        right: 50px;
        padding: 10px;
      "
    >

      <ul class="list-unstyled mb-0 heightmaxed">
        <li v-if="notifications.length === 0" class="px-3 py-2 text-center text-muted">
          No notifications
        </li>

 
        <li
          v-for="(n, idx) in notifications"
          :key="idx"
          class="px-3 py-2 border-bottom"
          style="font-size: 0.9rem;"
        >
          {{ formatNotification(n) }}
        </li>
      </ul>
      <button v-if="notifications.length != 0" class="btn btn-default btn-outline px-2 py-0 mt-2 float-right" @click.prevent="clearnotification()">
            
            <span class="bold">Clear</span>
          </button>
    </div>
  </transition>
  <!-- Upload study protocol modal Ends -->
</template>

<script src="./ImportStudy.js"></script>

<style scoped>
.blank-wrapper{
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 30%);
  color:rgb(255, 255, 255);
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  z-index: 3000;
  pointer-events: auto;
}
.step-indicator {
  position: relative;
  display: flex;
  justify-content: space-between;
  margin: 2px 0;
  padding: 0 15px;
}

.step-indicator::before {
  content: '';
  position: absolute;
  top: 15px;
  left: 0;
  right: 0;
  height: 2px;
  background: #dee2e6;
  z-index: 1;
}

.step {
  position: relative;
  z-index: 2;
  text-align: center;
  flex-direction: column;
  align-items: center;
}

.step-number {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #dee2e6;
  color: #6c757d;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 8px;
  font-weight: 400;
  font-size: .8rem;
  transition: all 0.3s ease;
}

.step.active .step-number {
  background: #1a6fc4;
  color: white;
  box-shadow: 0 0 0 6px rgba(26, 111, 196, 0.15);
}

.step.completed .step-number {
  background: #198754;
  color: white;
}

.step-label {
  font-size: 0.8rem;
  color: #6c757d;
  font-weight: 500;
  transition: all 0.3s ease;
}

.step.active .step-label {
  color: #1a6fc4;
  font-weight: 600;
}

.step.completed .step-label {
  color: #198754;
}
.stepper-status{
  font-size: 0.8rem;
  padding: 2px 8px;
  border-radius: 12px;
  margin-top: 4px;
}
.stepper-status-active {
    background-color: #dbeafe;
    color: #1d4ed8;
    font-weight:500
}

/*loader style */
.custom-w{
  width:25px;
 } 
import-loader {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.import-primary-loading:before,
.import-primary-loading:after {
  position: absolute;
  top: 0;
  content: '';
}

.import-primary-loading:before {
  left: -5px;
}

.import-primary-loading:after {
  left: 5px;
  -webkit-animation-delay: 0.32s !important;
  animation-delay: 0.32s !important;
}

.import-primary-loading:before,
.import-primary-loading:after,
.import-primary-loading {
  background: #076fe5;
  -webkit-animation: loading-keys-app-loading 0.8s infinite ease-in-out;
  animation: loading-keys-app-loading 0.8s infinite ease-in-out;
  width: 2px;
  height: 32px;
}

.import-primary-loading {
  text-indent: -9999em;
  margin: auto;
  position: absolute;
  left:50%;
  top:50%;
  -webkit-animation-delay: 0.16s !important;
  animation-delay: 0.16s !important;
}

@-webkit-keyframes loading-keys-app-loading {

  0%,
  80%,
  100% {
    opacity: .75;
    box-shadow: 0 0 #076fe5;
    height: 2px;
  }

  40% {
    opacity: 1;
    box-shadow: 0 -8px #076fe5;
    height: 8px;
  }
}

@keyframes loading-keys-app-loading {

  0%,
  80%,
  100% {
    opacity: .75;
    box-shadow: 0 0 #076fe5;
    height: 2px;
  }

  40% {
    opacity: 1;
    box-shadow: 0 -8px #076fe5;
    height: 8px;
  }
}
/* loader styles*/ 

.card {
  border-radius: 10px;
  border: none;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  margin-bottom: 25px;
  transition: transform 0.3s;
}

.card-header {
  background-color: var(--card-header);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  font-weight: 600;
  padding: 15px 20px;
  border-radius: 10px 10px 0 0 !important;
}

.card-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
}

.card-title i {
  background-color: var(--primary-light);
  color: var(--primary);
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Import Section */
.import-box {
  border: 2px dashed #cbd5e1;
  border-radius: 10px;
  padding: 15px 30px;
  text-align: center;
  background-color: #f8fafc;
  cursor: pointer;
  transition: all 0.3s;
  margin-bottom: 20px;
}

.import-box:hover {
  border-color: var(--primary);
  background-color: rgba(37, 99, 235, 0.05);
}

.import-icon {
  font-size: 48px;
  color: var(--primary);
  margin-bottom: 15px;
}

/* Status Badges */
.badge-draft {
  background-color: #fef3c7;
  color: #92400e;
}

.badge-approved {
  background-color: #d1fae5;
  color: #065f46;
}

.badge-pending {
  background-color: #dbeafe;
  color: #1e40af;
}

.badge-completed {
  background-color: #dcfce7;
  color: #166534;
}

.btn-success {
  background-color: transparent;
  border-color: var(--secondary-clr);
  border-radius: 0;
  font-size: 0.8rem;
}

.btn-success:hover,
.btn-success:focus {
  color: #fff;
  background-color: #1a7bb9;
  border-color: #1a7bb9;
}

.btn {
  padding-block: 0.2rem;
}

.plan-side-popup {
  position: absolute;
  text-align: left;
  right: 56px;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  width: min(124px, 90%);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.plan-side-popup>div {
  cursor: pointer;
  padding: 0.5rem;
}

.plan-side-popup>div:hover {
  background-color: #e4eaf9;
}

.study_profile_modal__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden;
  z-index: 3000;
}

.study_profile_modal__container {
  position: fixed;
  border-radius: 4px;
  background: #fff;
}

.modal__title {
  background-color: var(--pop-up-background);
  color: white;
  border: 0px;
  border-radius: 4px 4px 0px 0px;
}

.float-right .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 15px;
  top: -15px;
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}

.float-right:hover .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}

.custom-width {
  width: min(500px, 90%);
}

.PrivilegeModal-custom-width {
  width: min(900px, 90%);
}

.modal-wrapper-forms {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden;
  z-index: 3000;
}

.modelbody {
  overflow: unset !important;
}

.modelbody {
  background: #fff;
  margin: 0;
  padding: 5%;
}

.multiselect-template-theme {
  --ms-option-bg-selected-pointed: rgb(210, 210, 210);
  --ms-option-bg-selected: rgb(210, 210, 210);
  --ms-option-color-selected: #000;
  --ms-option-color-selected-pointed: #000;
  --ms-radius: 0;
  --ms-line-height: 0.8;
  --ms-option-font-size: 0.8rem;
  --ms-font-size: 0.8rem;
}

.overflow-block-form {
  width: 100%;
  padding: 8px 8px;
  overflow-x: scroll;
}

.scroll_horizontal {
  height: 400px;
  overflow: auto;
}

.heightmaxed {
  max-height: 260px;
  max-width: 240px;
  overflow-y: auto;
}

.al_min-height {
  min-height: 40px;
}


/* Table Styling with Scroll */
.table-container {
  max-height: 200px !important;
  overflow: auto;
  position: relative;
}

.table-container table {
  max-width: 1000px;
  width: 100%;
}

.table th {
  background-color: #ffffff;
  font-weight: 600;
  color: var(--dark);
  border-top: none;
  padding: 2px 16px;
  position: sticky;
  top: 0;
  z-index: 10;
}

.table td {
  padding: 2px 16px;
  vertical-align: middle;
}

.table tr:hover {
  background-color: rgba(219, 234, 254, 0.3);
}

/* Scrollbar styling */
.table-container::-webkit-scrollbar {
  width: 4px;
  height: 8px;
}

.table-container::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

</style>